// src/integrations/enode/manifest.js
import logo from './logo.svg';

const enodeManifest = {
  slug: 'enode',
  type: 'Integrations::EnodeIntegration',
  displayName: 'Enode',
  asset_sync_message:
    'Use the API base URL that matches your Enode client environment (sandbox: https://enode-api.sandbox.enode.io; production: https://enode-api.production.enode.io). Dashboard clients are sandbox-only. Sync imports linked chargers, vehicles, HVACs, inverters, batteries, meters, and HEM systems. Manual sync uses kind:uuid (e.g. charger:2211e263-0362-4235-83f4-887bdf3ee414).',
  logo,
  colorClass: 'bg-white',
};

export default enodeManifest;
